import { render, staticRenderFns } from "./GuideAndVideoInfo.vue?vue&type=template&id=b36f0ab2&scoped=true"
import script from "./GuideAndVideoInfo.vue?vue&type=script&lang=js"
export * from "./GuideAndVideoInfo.vue?vue&type=script&lang=js"
import style0 from "./GuideAndVideoInfo.vue?vue&type=style&index=0&id=b36f0ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36f0ab2",
  null
  
)

export default component.exports